import {
  Apollo_gql,
  GraphPayload,
  GraphQueryInput,
  GraphQueryPayload,
  createQuery,
  graphQlTake,
} from '@camelot/server';

import { functionProps } from './dto/function';
import { tenantInformationsProps } from './dto/tenant-information';
import { User, userProps } from './dto/user';

export function GET_USER_BY_ID(id: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query GetUserById($id: UUID!) {
          userById(id: $id) {
              ${userProps.get('id')}
              ${userProps.get('userName')}
              ${userProps.get('firstName')}
              ${userProps.get('lastName')}
              ${userProps.get('phoneNumber')}
              ${userProps.get('isCompany')}
              ${userProps.get('isDisabled')}
              ${userProps.get('culture')}
              ${userProps.get('trigram')}
              ${userProps.get('picture')}
              ${userProps.get('pictureDocumentId')}
              ${userProps.get('functions')} {
                ${functionProps.get('id')}
                ${functionProps.get('name')}
              }
            }
          }
      `,
    variables: {
      id: id,
    },
  };
}

export function GET_CURRENT_USER(withPermissions: boolean): GraphPayload {
  return createQuery<User>('currentUser', {
    operation: 'GetCurrentUser',
    props: `
      ${userProps.get('id')}
      ${userProps.get('userName')}
      ${userProps.get('firstName')}
      ${userProps.get('lastName')}
      ${userProps.get('phoneNumber')}
      ${userProps.get('isCompany')}
      ${userProps.get('culture')}
      ${userProps.get('trigram')}
      ${userProps.get('picture')}
      ${userProps.get('pictureDocumentId')}
      ${userProps.get('tenantInformations')} {
        ${tenantInformationsProps.get('tenantPersonId')}
        ${tenantInformationsProps.get('tenantId')}
        ${tenantInformationsProps.get('tenantName')}
      }
      ${withPermissions ? userProps.get('permissions') : ''}
    `,
    take: -1,
  });
}

export function GET_USERS(where: string, props: string, order: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query Users {
        users(${order}, ${where}, ${graphQlTake()}) {
          items {
            ${props}
          }
        }
      }
    `,
    variables: {},
  };
}

export function GET_FUNCTIONS(where: string, props: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query Functions {
        functions(${where}, ${graphQlTake()}) {
          items {
            ${props}
          }
        }
      }
    `,
    variables: {},
  };
}

export function GET_DAY_AVAILABILITIES(where: string, props: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query DayAvailabilities {
        dayAvailabilities(${where}, ${graphQlTake()}) {
          items {
            ${props}
          }
        }
      }
    `,
    variables: {},
  };
}

export function GET_PLANNING_AVAILABILITIES<T>(input: GraphQueryInput<T>): GraphPayload {
  return createQuery<T>('planningDayAvailabilities', { ...input, prefixType: 'DayAvailability' });
}

export function GET_ROLES(where: string, props: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query Roles {
        roles(${where}, ${graphQlTake()}) {
          items {
            ${props}
          }
        }
      }
    `,
    variables: {},
  };
}

export function GET_USERS_CUSTOMERS(where: string, props: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query UsersCustomers {
        usersCustomers(${where}, ${graphQlTake()}) {
          items {
            ${props}
          }
        }
      }
    `,
    variables: {},
  };
}

export function GET_SEARCH_USERS_CUSTOMERS(filter: string, props: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
    query UsersCustomers {
        searchUsersCustomers(filter: "${filter}", ${graphQlTake()}) {
            totalCount
            items {
                ${props}
            }
        }
    }
    `,
    variables: {},
  };
}

export function GET_MY_CONTACTS(): GraphQueryPayload {
  return {
    query: Apollo_gql`
      query MyContacts {
        myContacts
      }
    `,
    variables: {},
  };
}
